import { Modal, Row, Col, Card, CarouselItem, Table } from 'react-bootstrap'
import React, { Component } from 'react'
import parse, { domToReact } from 'html-react-parser';
import './summary.scss';

class TotalStudentDataModal extends Component {

    renderColumn = (label, students, theme) => {
        const list = students || [];
        return (
            <Col xl={4} lg={4} md={4} sm={12} className="mb-3 mb-lg-0">
                <div style={{ border: "1px solid #ebe9f7", borderRadius: 14, overflow: "hidden", background: "#ffffff", boxShadow: "0 2px 10px rgba(33,48,70,0.05)", height: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", background: theme.headBg, borderBottom: `1px solid ${theme.border}` }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 700, letterSpacing: "0.4px", textTransform: "uppercase", color: theme.text }}>
                            <span style={{ width: 9, height: 9, borderRadius: "50%", background: theme.dot }} />
                            {label}
                        </span>
                        <span style={{ minWidth: 24, height: 22, padding: "0 7px", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: 11, background: theme.dot, color: "#ffffff", fontSize: 12, fontWeight: 700 }}>
                            {list.length}
                        </span>
                    </div>
                    <div style={{ maxHeight: 360, overflowY: "auto" }}>
                        {list.length === 0 ? (
                            <p style={{ textAlign: "center", color: "#94a3b8", fontSize: 13, padding: "18px 0", margin: 0 }}>No students</p>
                        ) : (
                            list.map((item, idx) => (
                                <p key={idx} style={{ margin: 0, padding: "8px 14px", fontSize: 13, color: "#334155", borderBottom: "1px solid #f4f4fb", textAlign: "center" }}>
                                    {item.name}
                                </p>
                            ))
                        )}
                    </div>
                </div>
            </Col>
        );
    }

    render() {
        let stateData = this.props.data;
        let questionid = stateData.slno;
        let questionData = this.props.data.studentResults.filter((item) => item.slno == questionid);
        let questionRealId = questionData[0]?.question_id;
        let correct = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '2')
        let wrong = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '1')
        let unanswered = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '0')

        return (

            <Modal {...this.props}
                size="lg" aria-labelledby="example-modal-sizes-title-lg" className="" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg text-center">
                        Student Results
                        {questionRealId ? (
                            <span style={{ marginLeft: 10, fontSize: 14, fontWeight: 600, color: "#64748b" }}>
                                (Question ID: {questionRealId})
                            </span>
                        ) : null}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#f7f7fc" }}>
                    <Row className="g-3">
                        {this.renderColumn("Correct", correct, { headBg: "#ecfdf5", border: "#bbf7d0", text: "#15803d", dot: "#16a34a" })}
                        {this.renderColumn("Wrong", wrong, { headBg: "#fef2f2", border: "#fecaca", text: "#b91c1c", dot: "#ef4444" })}
                        {this.renderColumn("Unanswered", unanswered, { headBg: "#fffbeb", border: "#fde68a", text: "#b45309", dot: "#f59e0b" })}
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default TotalStudentDataModal;
